import api from './axiosService';

export const userApi = {
    getAll(params = {}) {
        return api.get('/user-accounts', { params });
    },

    getById(id) {
        return api.get(`/user-accounts/${id}`);
    },

    getAllUsersWithRoles(params = {}) {
        return api.get('/user-accounts/all-with-roles', { params });
    },
    
    getByEmail(email) {
        return api.get(`/user-accounts/email/${encodeURIComponent(email)}`);
    },

    getByUsername(username) {
        return api.get(`/user-accounts/username/${encodeURIComponent(username)}`);
    },

    create(data) {
        return api.post('/user-accounts', data);
    },

    update(id, data) {
        return api.put(`/user-accounts/${id}`, data);
    },

    // User Account only
    activate(id) {
        return api.patch(`/user-accounts/${id}/activate`);
    },

    deactivate(id) {
        return api.patch(`/user-accounts/${id}/deactivate`);
    },

    // User Login only
    activateLogin(id) {
        return api.patch(`/user-accounts/${id}/activate-login`);
    },

    deactivateLogin(id) {
        return api.patch(`/user-accounts/${id}/deactivate-login`);
    },

    // Both tables
    activateBoth(id) {
        return api.patch(`/user-accounts/${id}/activate-both`);
    },

    deactivateBoth(id) {
        return api.patch(`/user-accounts/${id}/deactivate-both`);
    },

    changeRole(id, role) {
        return api.put(`/user-accounts/${id}/role`, { role });
    },

    changeUserPassword(id, newPassword) {
        return api.put(`/user-accounts/${id}/change-password`, {
            new_password: newPassword,
        });
    },

    getPermissions(id) {
        return api.get(`/user-accounts/${id}/permissions`);
    },
};